module.exports = __webpack_public_path__ + "f098da346ef13e0778758337dee409b1.MP3";